<template>
  <div class="logo">
    <router-link :to="{name:'welcome'}">
    <!--   <LogoSvg alt="logo" /> -->
<!--       <img :src="config.imgApiUrl + companyLogoId" alt="" class="logo">  -->
      <h1 style="font-size: 24px;" v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
import LogoSvg from '@/assets/logogb.svg?inline'
import storage from '@/utils/storage'

export default {
  name: 'Logo',
  components: {
    LogoSvg
  },
  props: {
    title: {
      type: String,
      default: '智能物流系统',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      companyLogoId: ''
    }
  },
  created() {
    this.companyLogoId = storage.fetch('cache-companyLogoId')
  }
}
</script>

<style scoped>
.title{
  height: 200px;
  background-size: 100% 100%;
}
</style>
